import { render, staticRenderFns } from "./FeedbackView.vue?vue&type=template&id=20a85ee0&scoped=true"
import script from "./FeedbackView.vue?vue&type=script&lang=js"
export * from "./FeedbackView.vue?vue&type=script&lang=js"
import style0 from "./FeedbackView.vue?vue&type=style&index=0&id=20a85ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a85ee0",
  null
  
)

export default component.exports